import { Grid } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
  hasBottomBorder: boolean;
  hasRightBorder: boolean;
  children: ReactNode;
};

export const CellWrapper = ({
  hasBottomBorder,
  hasRightBorder,
  children,
}: Props) => (
  <Grid
    sx={{
      flex: "1 1",
      minHeight: "60px",
      height: "9vh",
      maxHeight: "80px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRight: hasRightBorder
        ? (theme) => `1px solid ${theme.palette.divider}`
        : "none",
      borderBottom: hasBottomBorder
        ? (theme) => `1px solid ${theme.palette.divider}`
        : "none",
    }}
  >
    {children}
  </Grid>
);
